import { useState } from "react";
import { Link } from "react-router-dom";
import { Users, MapPinned, QrCode, CalendarClock, CheckCircle2, AlertTriangle, MapPinOff, Camera, Siren, IdCard, Ban } from "lucide-react";
import { Title, Loading, Table, fmtDT, useData, todayTR } from "@/ops/ui";
import { FilterBar, mapsLink } from "@/ops/filters";

const CARDS = [
  ["employees", "Toplam aktif personel", Users, "/operasyon/personel"], ["projects", "Aktif proje", MapPinned, "/operasyon/projeler"],
  ["checkpoints", "Aktif kontrol noktası", QrCode, "/operasyon/gps"], ["r.planned", "Bugün planlanan kontrol", CalendarClock, "/operasyon/devriye"],
  ["r.completed", "Tamamlanan kontrol", CheckCircle2, "/operasyon/devriye"], ["missing_late", "Eksik / geciken", AlertTriangle, "/operasyon/raporlar"],
  ["gps_bad", "GPS doğrulaması başarısız", MapPinOff, "/operasyon/canli"], ["rejected", "Reddedilen okutma", Ban, "/operasyon/canli"],
  ["photo_pending", "Fotoğraf bekleyen görev", Camera, "/operasyon/fotografli"], ["open_incidents", "Açık olay bildirimi", Siren, "/operasyon/olaylar"],
  ["expiring", "Süresi yaklaşan belge / kart", IdCard, "/operasyon/belgeler"],
];

const value = (d, k) => ({
  "r.planned": d.rounds.planned, "r.completed": d.rounds.completed, missing_late: d.rounds.missing + d.rounds.late,
  gps_bad: d.gps_failed_scans, expiring: d.docs_expiring + d.cards_expiring,
}[k] ?? d[k]);

export default function OpsDashboard() {
  const [f, setF] = useState({ day: todayTR(), project_id: "", employee_id: "" });
  const [d] = useData("/ops/admin/overview", f);
  const [locs] = useData("/ops/admin/locations/latest");
  return (
    <div>
      <Title title="Yönetim Paneli" desc="Tüm sayılar canlı veritabanından alınır (Türkiye saati)." />
      <FilterBar f={f} setF={setF} range={false} />
      {!d ? <Loading /> : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map(([k, label, Icon, to]) => (
            <Link key={k} to={to} className="rounded-lg border border-zinc-200 bg-white p-4 transition-colors hover:border-[color:var(--red)]" data-testid={`ops-stat-${k.replace(".", "-")}`}>
              <Icon className="h-5 w-5 text-[color:var(--red)]" />
              <p className="mt-3 text-3xl font-extrabold text-zinc-950">{value(d, k)}</p>
              <p className="text-sm text-zinc-500">{label}</p>
            </Link>
          ))}
        </div>
      )}
      <h2 className="mb-3 mt-8 text-lg font-bold">Son paylaşılan personel konumları</h2>
      {!locs?.length ? <p className="rounded-lg border border-dashed border-zinc-300 bg-white p-6 text-sm text-zinc-500" data-testid="ops-locations-empty">Henüz konum paylaşımı yok. Yalnızca personelin izin verip gerçekten gönderdiği konumlar gösterilir.</p> : (
        <Table head={["Personel", "Proje", "Zaman", "Konum", "Doğruluk"]} testid="ops-locations-table">
          {locs.map((l) => <tr key={l.id}><td className="px-3 py-2 font-semibold">{l.employee_name}</td><td className="px-3 py-2">{l.project_name}</td><td className="px-3 py-2">{fmtDT(l.at)}</td><td className="px-3 py-2"><a className="text-blue-700 underline" target="_blank" rel="noreferrer" href={mapsLink(l.lat, l.lng)}>Haritada aç</a></td><td className="px-3 py-2">{l.accuracy ? `${Math.round(l.accuracy)} m` : "-"}</td></tr>)}
        </Table>
      )}
    </div>
  );
}
